/**
 * Props for the currency formatter function
 */
export type CurrencyFormatterOptions = {
  /**
   * The locale to use for the currency formatter
   * @default "en-US"
   */
  locale?: Intl.LocalesArgument;
  /**
   * The currency to use for the currency formatter
   * @default "USD"
   */
  currency?: Intl.NumberFormatOptions["currency"];
};

/**
 * Helper function for formatting table cells with currency, including i18n support
 * @param value - The value to format
 * @param options - The options for the currency formatter
 * @returns The formatted currency
 */
export const currencyFormatter = (
  value?: number,
  options: CurrencyFormatterOptions = {},
) => {
  const { locale = "en-US", currency = "USD" } = options;

  return value != null
    ? value.toLocaleString(locale, {
        style: "currency",
        currency,
      })
    : null;
};
